import React from "react";
import { copyLinkHandler, referNowHandler } from "../../Utils/Referral";

const ReferCard = ({ referCode }) => {

    return (
        <div>
            <h1 className="font-gilroy-semibold text-xl">Refer & Earn more discount...</h1>
            <div className="mt-2 rounded-lg overflow-hidden bg-[linear-gradient(to_right,_#e6feef_0%,_#cefde0_5%,_#AFFCCD_50%,_#cefde0_95%,_#e6feef_100%)]">
                <div className="flex flex-row items-center gap-1 p-1 pl-2.5">
                    <div className="flex-1 font-gilroy-medium text-[17px] text-black overflow-hidden">
                        {referCode
                            ? <p className="overflow-hidden text-ellipsis whitespace-nowrap">https://feedants.com/#/referral/{referCode}</p>
                            : <div className="place-self-center size-6 border-2 border-[#008080] border-t-white animate-spin rounded-full" />
                        }
                    </div>
                    <button className="p-2 rounded-lg font-gilroy-semibold text-[12px] text-[#008080] p-1 bg-white self-center" disabled={!referCode} onClick={() => copyLinkHandler(referCode)}>
                        Copy link
                    </button>
                </div>
                <button
                    className="w-full rounded-lg py-2.5 border-1 border-[#008080] bg-white font-gilroy-semibold text-[#008080]" 
                    disabled={!referCode} 
                    onClick={() => referNowHandler(referCode)}
                >
                    Refer Now
                </button>
            </div>
        </div>
    );
};

export default ReferCard;